import { createApp } from 'vue';
import VueCropper from './index.vue';

function initInstance(props) {
  const rootId = 'tip-match-img-cropper';
  const oldRoot = document.getElementById(rootId);
  if (oldRoot) {
    document.body.removeChild(oldRoot);
  }
  const cropperRootDiv = document.createElement('div');
  cropperRootDiv.id = rootId;

  document.body.appendChild(cropperRootDiv);

  const app = createApp(VueCropper, props);
  app.mount(cropperRootDiv);
}

function Cropper(options) {
  initInstance(options);
}

Cropper.setDefaultOptions = (options) => {
  Object.assign(Cropper.currentOptions, options);
};

Cropper.show = (options) => {
  Cropper({
    ...options,
  });
};

export default Cropper;
